"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.userChallengeRankingSelector = exports.challengeRankingFiltersSelector = exports.challengeRankingSkipSelector = exports.challengeRankingCountSelector = exports.challengeRankingDataSelector = exports.challengeRankingSelector = exports.rankingFiltersSelector = exports.rankingSkipSelector = exports.rankingCountSelector = exports.rankingDataSelector = exports.rankingSelector = void 0;

var _reselect = require("reselect");

var rankingsSelector = function rankingsSelector(state) {
  return state.rankings;
};

var rankingSelector = (0, _reselect.createSelector)(rankingsSelector, function (rankingState) {
  return rankingState.ranking;
});
exports.rankingSelector = rankingSelector;
var rankingDataSelector = (0, _reselect.createSelector)(rankingSelector, function (ranking) {
  return ranking ? ranking.data : null;
});
exports.rankingDataSelector = rankingDataSelector;
var rankingMetaSelector = (0, _reselect.createSelector)(rankingSelector, function (ranking) {
  return ranking ? ranking.meta : null;
});
var rankingCountSelector = (0, _reselect.createSelector)(rankingMetaSelector, function (metaRanking) {
  return metaRanking ? metaRanking.count : null;
});
exports.rankingCountSelector = rankingCountSelector;
var rankingSkipSelector = (0, _reselect.createSelector)(rankingMetaSelector, function (metaRanking) {
  return metaRanking ? metaRanking.skip : null;
});
exports.rankingSkipSelector = rankingSkipSelector;
var rankingFiltersSelector = (0, _reselect.createSelector)(rankingsSelector, function (rankingState) {
  return rankingState.rankingFilters;
});
exports.rankingFiltersSelector = rankingFiltersSelector;
var challengeRankingSelector = (0, _reselect.createSelector)(rankingsSelector, function (rankingState) {
  return rankingState.challengeRanking;
});
exports.challengeRankingSelector = challengeRankingSelector;
var challengeRankingDataSelector = (0, _reselect.createSelector)(challengeRankingSelector, function (challengeRanking) {
  return challengeRanking ? challengeRanking.data : null;
});
exports.challengeRankingDataSelector = challengeRankingDataSelector;
var challengeRankingMetaSelector = (0, _reselect.createSelector)(challengeRankingSelector, function (challengeRanking) {
  return challengeRanking ? challengeRanking.meta : null;
});
var challengeRankingCountSelector = (0, _reselect.createSelector)(challengeRankingMetaSelector, function (metaChallengeRanking) {
  return metaChallengeRanking ? metaChallengeRanking.count : null;
});
exports.challengeRankingCountSelector = challengeRankingCountSelector;
var challengeRankingSkipSelector = (0, _reselect.createSelector)(challengeRankingMetaSelector, function (metaChallengeRanking) {
  return metaChallengeRanking ? metaChallengeRanking.skip : null;
});
exports.challengeRankingSkipSelector = challengeRankingSkipSelector;
var challengeRankingFiltersSelector = (0, _reselect.createSelector)(rankingsSelector, function (rankingState) {
  return rankingState.challengeRankingFilters;
});
exports.challengeRankingFiltersSelector = challengeRankingFiltersSelector;
var userChallengeRankingSelector = (0, _reselect.createSelector)(rankingsSelector, function (rankingState) {
  return rankingState.userChallengeRanking;
});
exports.userChallengeRankingSelector = userChallengeRankingSelector;
var _default = {
  userChallengeRankingSelector: userChallengeRankingSelector,
  rankingSelector: rankingSelector,
  rankingDataSelector: rankingDataSelector,
  rankingCountSelector: rankingCountSelector,
  rankingSkipSelector: rankingSkipSelector,
  rankingFiltersSelector: rankingFiltersSelector,
  challengeRankingSelector: challengeRankingSelector,
  challengeRankingDataSelector: challengeRankingDataSelector,
  challengeRankingCountSelector: challengeRankingCountSelector,
  challengeRankingSkipSelector: challengeRankingSkipSelector,
  challengeRankingFiltersSelector: challengeRankingFiltersSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map